import { render, staticRenderFns } from "./DialogMediaUnitManipulatorWithBackgroundKnobs.vue?vue&type=template&id=10a9af0a&"
import script from "./DialogMediaUnitManipulatorWithBackgroundKnobs.vue?vue&type=script&lang=js&"
export * from "./DialogMediaUnitManipulatorWithBackgroundKnobs.vue?vue&type=script&lang=js&"
import style0 from "./DialogMediaUnitManipulatorWithBackgroundKnobs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports